import { lazy } from "react";
import { routeProps } from "Services/Share.props";
import RenderSubSection from "./RenderSubSections";

const DryReceivingList = lazy(() => import("pages/DryReceiving/List"));
const DryReceivingDetail = lazy(() => import("pages/DryReceiving/Detail"));
const ReceivingList = lazy(() => import("pages/Receiving/List"));
const ReceivingDetail = lazy(() => import("pages/Receiving/Detail"));
const ReceivingUploadImage = lazy(() => import("pages/Receiving/UploadImage"));
const ReceivingTimeList = lazy(() => import("pages/Receiving/Time"));

const dryReceivingList = {
    name: "دریافتی بار خشک",
    path: "/dry-receiving",
    group: "dry-receiving",
    exact: true,
    component: (props: routeProps) => <DryReceivingList {...props} />,
};

const dryReceivingDetail = {
    name: "جزییات دریافتی بار خشک",
    path: "/dry-receiving-detail/:id",
    group: "dry-receiving-detail",
    isHide: true,
    component: (props: routeProps) => <DryReceivingDetail {...props} />,
};

const receivingList = {
    name: "دریافتی",
    path: "/receiving-daily",
    group: "receiving-daily",
    exact: true,
    component: (props: routeProps) => <ReceivingList {...props} />,
};

const receivingDetail = {
    name: "جزییات دریافتی",
    path: "/receiving-daily-detail/:id/:id",
    group: "receiving-daily-detail",
    isHide: true,
    component: (props: routeProps) => <ReceivingDetail {...props} />,
};

const receivingViewImage = {
    name: "نمایش عکس دریافتی",
    path: "/receiving-upload-image",
    group: "receiving-upload",
    isHide: true,
    component: (props: routeProps) => <ReceivingUploadImage {...props} />,
};

const receivingTime = {
    name: "زمان تحویل",
    path: "/arrival-time",
    group: "arrival-time",
    exact: true,
    component: (props: routeProps) => <ReceivingTimeList {...props} />,
};

const subSections = {
    main: {
        list: { ...receivingList },
        create: { ...receivingDetail },
        view: { ...receivingViewImage },
        file: { ...receivingViewImage },
    },
    time: {
        list: { ...receivingTime },
    },
    dry: {
        list: { ...dryReceivingList },
        create: { ...dryReceivingDetail },
    },
};

const receivingSection = {
    title: "تحویل سفارشات",
    key: "receiving",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default receivingSection;
